export const iconFontAwesomeUsersPeopleUsersGear = (
	<i className="fa-solid fa-users-gear"></i>
);
